export enum ContentType {
  IMAGE = 'IMAGE',
  PRODUCT = 'PRODUCT',
  VIDEO = 'VIDEO',
  AUDIO = 'AUDIO',
}
